export async function enableMocking() {
  // MSW mocking has been disabled - all endpoints are connected to real API
  return;
}
